import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '@/views/Home.vue'
import SurveyConfirmation from '@/views/SurveyConfirmation.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/potwierdz-ankiete',
    name: 'survey-confirmation',
    component: SurveyConfirmation,
    meta: {
      title: 'PSE - Potwierdź ankietę'
    }
  },
  {
    path: '/:questionnaire',
    name: 'questionnaire',
    component: Home,
    meta: {
      title: 'PSE'
    }
  },
  {
    path: '',
    name: 'Home',
    component: Home,
    meta: {
      title: 'PSE'
    }
  },

  {
    name: 'not-found',
    path: '/error/not-found',
    component: () => import('@/views/NotFound.vue'),
    meta: {
      title: 'PSE - Strona nie została znaleziona'
    }
  },
  // catch all 404 - define at the very end
  {
    path: '*',
    redirect: 'not-found'
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

// router.push({ name: 'questionnaire' })

export default router
